import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { actions } from '@/redux/av-check';
import {
  CmsPageContentIdentifier,
  CmsPageContentType,
  Feature,
  FilterCriteriaType,
  FilterValuesType,
  ReduxStateType,
  TargetGroup,
  TariffOfferType,
} from '@/types/av-check';

import {
  getAvailableTargetGroups, getTariffOffers, hasMatchedTariff,
} from '@/utils';

import Item from './Item';

export interface StateProps {
  filterValues: FilterValuesType,
  cmsContent: CmsPageContentType
  tariffOffers: TariffOfferType[],
  enabledFeatures: Feature[],
}

export interface DispatchProps {
  setCurrentTargetGroup: Function,
  setSpecialReservations: Function
}

const TargetGroupSwitcher = ({
  filterValues,
  cmsContent,
  tariffOffers,
  setCurrentTargetGroup,
  setSpecialReservations, enabledFeatures,
} : StateProps & DispatchProps) => {
  const matchedTargetGroups: TargetGroup[] = getAvailableTargetGroups(tariffOffers);
  const matchedSpecialReservations: boolean = hasMatchedTariff(tariffOffers, FilterCriteriaType.SPECIAL_RESERVATION, true);
  const isDtagGeneralToggleEnabled: boolean = enabledFeatures.includes(Feature.DTAG_GENERAL);
  return (
    <div className="switcher segment-switcher checkbox" style={{ flexWrap: matchedSpecialReservations ? 'wrap' : 'nowrap' }}>
      <div className="switcher-text" dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.TargetGroupSwitcherLabel] }} />
      <div className="switcher-box">
        {matchedTargetGroups.indexOf(TargetGroup.PRIVATKUNDEN) >= 0
              && (
              <Item
                id={TargetGroup.PRIVATKUNDEN}
                checked={filterValues.TARGET_GROUP === TargetGroup.PRIVATKUNDEN && filterValues.SPECIAL_RESERVATION === false}
                onSelect={() => {
                  setCurrentTargetGroup(TargetGroup.PRIVATKUNDEN);
                  setSpecialReservations(false);
                }}
                label = {isDtagGeneralToggleEnabled
                    ? cmsContent[CmsPageContentIdentifier.TargetGroupNamePrivatkundenInfoIcon]
                    : cmsContent[CmsPageContentIdentifier.TargetGroupNamePrivatkunden]}
                tooltip={isDtagGeneralToggleEnabled
                    ? undefined
                    : cmsContent[CmsPageContentIdentifier.TargetGroupNamePrivatkundenInfo]}
              />
              )}
        {matchedTargetGroups.indexOf(TargetGroup.BESTANDSKUNDEN) >= 0
            && (
                <Item
                    id={TargetGroup.BESTANDSKUNDEN}
                    checked={filterValues.TARGET_GROUP === TargetGroup.BESTANDSKUNDEN && filterValues.SPECIAL_RESERVATION === false}
                    onSelect={() => {
                      setCurrentTargetGroup(TargetGroup.BESTANDSKUNDEN);
                      setSpecialReservations(false);
                    }}
                    label = {isDtagGeneralToggleEnabled
                        ? cmsContent[CmsPageContentIdentifier.TargetGroupNameBestandskundenInfoIcon]
                        : cmsContent[CmsPageContentIdentifier.TargetGroupNameBestandskunden]}
                    tooltip={isDtagGeneralToggleEnabled
                        ? undefined
                        : cmsContent[CmsPageContentIdentifier.TargetGroupNameBestandskundenInfo]}
                />
            )}
        {matchedTargetGroups.indexOf(TargetGroup.SELBSTAENDIGE) >= 0
              && (
              <Item
                id={TargetGroup.SELBSTAENDIGE}
                checked={filterValues.TARGET_GROUP === TargetGroup.SELBSTAENDIGE && filterValues.SPECIAL_RESERVATION === false}
                onSelect={() => {
                  setCurrentTargetGroup(TargetGroup.SELBSTAENDIGE);
                  setSpecialReservations(false);
                }}
                label={isDtagGeneralToggleEnabled
                    ? cmsContent[CmsPageContentIdentifier.TargetGroupNameSebstaendigeInfoIcon]
                    : cmsContent[CmsPageContentIdentifier.TargetGroupNameSebstaendige]}
                tooltip={isDtagGeneralToggleEnabled
                    ? undefined
                    : cmsContent[CmsPageContentIdentifier.TargetGroupNameSebstaendigeInfo]}
              />
              )}
        {matchedTargetGroups.indexOf(TargetGroup.STUDENTEN) >= 0
            && (
                <Item
                    id={TargetGroup.STUDENTEN}
                    checked={filterValues.TARGET_GROUP === TargetGroup.STUDENTEN && filterValues.SPECIAL_RESERVATION === false}
                    onSelect={() => {
                      setCurrentTargetGroup(TargetGroup.STUDENTEN);
                      setSpecialReservations(false);
                    }}
                    label={isDtagGeneralToggleEnabled
                        ? cmsContent[CmsPageContentIdentifier.TargetGroupNameStudentenInfoIcon]
                        : cmsContent[CmsPageContentIdentifier.TargetGroupNameStudenten]}
                    tooltip={isDtagGeneralToggleEnabled
                        ? undefined
                        : cmsContent[CmsPageContentIdentifier.TargetGroupNameStudentenInfo]}
                />
            )}
      </div>
      {matchedSpecialReservations
        && (
        <div className="switcher-box" style={{ flexBasis: '100%', justifyContent: 'flex-end', marginTop: '8px' }}>
          <Item
            id={FilterCriteriaType.SPECIAL_RESERVATION}
            checked={filterValues.SPECIAL_RESERVATION === true}
            onSelect={() => {
              setCurrentTargetGroup(undefined);
              setSpecialReservations(true);
            }}
            label={cmsContent[CmsPageContentIdentifier.TargetGroupNameSonderbuchungen]}
          />
        </div>
        )}
    </div>
  );
};

const mapStateToProps = (state: ReduxStateType) => ({
  cmsContent: state.cmsContent,
  tariffOffers: getTariffOffers(state.result),
  filterValues: state.filterValues,
  enabledFeatures: state.enabledFeatures,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setCurrentTargetGroup:
    (targetGroup: TargetGroup) => dispatch(actions.setCurrentTargetGroup(targetGroup)),
  setSpecialReservations:
      (active: boolean) => dispatch(actions.setSpecialReservations(active)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TargetGroupSwitcher);
